import { Empty } from "antd";
import SelectAllCard from "../selectAll";
import ChequeBookRequestCard from "../chequeBookRequest";
import { useTranslation } from "react-i18next";

export default function ChequeBookList({
  dataSource = [],
  handleSelectAll,
  handleMultiApproveOrReject,
  selectAllChecked,
  handleMultiDelete,
  handleCheckBoxChange,
  handleApproveOrReject,
  handleDelete,
}) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          <div>
            <SelectAllCard
              record={dataSource}
              handleSelectAll={handleSelectAll}
              handleMultiApproveOrReject={handleMultiApproveOrReject}
              selectAllChecked={selectAllChecked}
              handleMultiDelete={handleMultiDelete}
            />
          </div>
          <div>
            {dataSource.map((option, index) => (
              <ChequeBookRequestCard
                record={option}
                handleCheckBoxChange={handleCheckBoxChange}
                handleApproveOrReject={handleApproveOrReject}
                handleDelete={handleDelete}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
